import React from 'react';
import OrderReturnManagementListSearchBox from '../OrderReturnManagementListSearchBox';
import OrderReturnManagementList from '../OrderReturnManagementList';
import { _LIST_PAGINATION_MODEL } from '../../../../../../store/modules/app/models';
import {
  ORDER_RETURN_MANAGEMENT_LIST_SEARCH_DATA_MODEL,
  ORDER_RETURN_MANAGEMENT_LIST_SEARCH_OPTION_MODEL,
} from '../../../../../../store/modules/order/models';
import { SEARCH_PERIOD_BUTTON_ALL_TYPE } from '../../../../../../constants/service/common/utilConstants';

const OrderReturnManagementListWrap = (props) => {
  const {
    orderReturnManagement,
    setData,
    getList,
    getAllListExcelDownload,
    getSelectedListExcelDownload,
    onCheckOrderItem,
    completeCollectionOrderReturn,
    failCollectionRejectOrderReturn,
    editReasonOrderReturn,
    completeOrderReturn,
    rejectOrderReturn,
    changeReturnToExchange,
    getOrderReturnAttachment,
  } = props;
  const { orderReturnManagementSelectedList, orderReturnManagementList } = orderReturnManagement;
  const {
    returnRequestDate,
    orderReturnStatusList,
    returnAcceptManagerList,
    orderItemDetailSearch,
    returnReasonTypeList,
    productType,
    store,
  } = orderReturnManagementList.searchData;

  return (
    <div className="order-return-management-list-wrap">
      <OrderReturnManagementListSearchBox
        setData={(data) =>
          setData({
            path: ['orderReturnManagement', 'orderReturnManagementList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        searchData={orderReturnManagementList.searchData}
        onSearch={() =>
          getList({
            searchOption: {
              /**
               *  반품 요청 일시
               */
              returnRequestDate:
                returnRequestDate.quickDateIndex !== SEARCH_PERIOD_BUTTON_ALL_TYPE ? returnRequestDate.period : null,
              /**
               *  상품 주문 반품 상태 리스트
               */
              orderReturnStatusList,
              /**
               *  반품 접수자 리스트
               */
              returnAcceptManagerList,
              /**
               *  상세 검색
               */
              orderItemDetailSearch,
              /**
               *  반품 사유 리스트
               */
              returnReasonTypeList,
              /**
               *  상품 타입
               */
              productType,
              /**
               *  판매처
               */
              store,
            },
            pagination: _LIST_PAGINATION_MODEL,
          })
        }
        onClear={() => {
          getList({
            searchOption: ORDER_RETURN_MANAGEMENT_LIST_SEARCH_OPTION_MODEL,
            pagination: _LIST_PAGINATION_MODEL,
          });
          setData({
            path: ['orderReturnManagement', 'orderReturnManagementList', 'searchData'],
            value: ORDER_RETURN_MANAGEMENT_LIST_SEARCH_DATA_MODEL,
          });
        }}
      />

      <OrderReturnManagementList
        orderReturnManagementList={orderReturnManagementList}
        orderReturnManagementSelectedList={orderReturnManagementSelectedList}
        getList={getList}
        getAllListExcelDownload={getAllListExcelDownload}
        getSelectedListExcelDownload={getSelectedListExcelDownload}
        onCheckOrderItem={onCheckOrderItem}
        completeCollectionOrderReturn={completeCollectionOrderReturn}
        failCollectionRejectOrderReturn={failCollectionRejectOrderReturn}
        editReasonOrderReturn={editReasonOrderReturn}
        completeOrderReturn={completeOrderReturn}
        rejectOrderReturn={rejectOrderReturn}
        changeReturnToExchange={changeReturnToExchange}
        getOrderReturnAttachment={getOrderReturnAttachment}
      />
    </div>
  );
};

export default OrderReturnManagementListWrap;
